import React from 'react';
import { createIcon } from '@chakra-ui/icon';
export default createIcon({
    displayName: 'CopyActiveIcon',
    path: (React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { d: "M0 0h24v24H0z" }),
        React.createElement("path", { d: "M19.5 6.5a2 2 0 012 2v11a2 2 0 01-2 2h-11a2 2 0 01-2-2v-11a2 2 0 012-2h11zm-15-1.97V17.5a2 2 0 01-2-2v-11a2 2 0 012-2h11a2 2 0 012 2h-2l-11 .03z", fill: "currentColor" }))),
});
//# sourceMappingURL=CopyActive.js.map